import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

type Entity = models.ManifiestosCargaDescargaFiltro;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Date = getField(kea.DateTime);
        return (
            <div>
                {kea.autogrid(3, [
                    <Date field="FechaInicio" label="Fecha de inicio" />,
                    <Date field="FechaFin" label="Fecha de fin" />
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaMovimientosCarga/list/cargasdescargas/filtro.tsx